import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgMagicWand = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5.25 7a.875.875 0 0 1 .875-.875h1.75v-1.75a.875.875 0 1 1 1.75 0v1.75h1.75a.875.875 0 0 1 0 1.75h-1.75v1.75a.875.875 0 0 1-1.75 0v-1.75h-1.75A.875.875 0 0 1 5.25 7Zm14.875 14h-.875v-.875a.875.875 0 1 0-1.75 0V21h-.875a.875.875 0 1 0 0 1.75h.875v.875a.875.875 0 1 0 1.75 0v-.875h.875a.875.875 0 0 0 0-1.75Zm6.125-5.25H24.5V14a.875.875 0 1 0-1.75 0v1.75H21a.875.875 0 1 0 0 1.75h1.75v1.75a.875.875 0 1 0 1.75 0V17.5h1.75a.875.875 0 0 0 0-1.75Zm-2.263-7L8.75 23.987a1.75 1.75 0 0 1-2.474 0l-2.264-2.262a1.752 1.752 0 0 1 0-2.475L19.25 4.013a1.75 1.75 0 0 1 2.475 0l2.262 2.262a1.75 1.75 0 0 1 0 2.475Zm-5.975 3.5L15.75 9.987l-10.5 10.5 2.262 2.263 10.5-10.5Zm4.738-4.737L20.487 5.25l-3.5 3.5 2.263 2.263 3.5-3.5Z" />
  </svg>
);
export default SvgMagicWand;
